<template>
  <div class="login-form">
    <h2>注册</h2>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="0"
      class="form"
    >
      <el-form-item prop="company">
        <el-input
          v-model="ruleForm.company"
          placeholder="请输入公司名"
        ></el-input>
      </el-form-item>
      <el-form-item prop="name">
        <el-input v-model="ruleForm.name" placeholder="请输入姓名"></el-input>
      </el-form-item>
      <el-form-item prop="phone">
        <el-input
          v-model="ruleForm.phone"
          placeholder="请输入手机号"
        ></el-input>
      </el-form-item>
      <el-form-item prop="captcha">
        <el-row>
          <el-col :span="12"
            ><el-input
              v-model="ruleForm.captcha"
              placeholder="请输入验证码"
            ></el-input
          ></el-col>
          <el-col :span="11" :offset="1">
            <el-button
              @click="getCaptcha"
              :disabled="captchaDisabled"
              class="captcha-btn"
              >获取验证码 <span v-if="showCountdown">({{ seconds }}s)</span>
            </el-button>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item prop="pwd">
        <el-input
          v-model="ruleForm.pwd"
          type="password"
          placeholder=" 密码"
        ></el-input>
      </el-form-item>
      <el-form-item prop="repwd">
        <el-input
          v-model="ruleForm.repwd"
          type="password"
          placeholder="确认密码"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')" size="small"
          >提 交</el-button
        >
        <router-link to="/login" class="login-btn">有账号，去登录</router-link>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "Register",

  data() {
    let validateRepwd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.pwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        company: "", // 公司
        name: "",
        phone: "",
        pwd: "",
        repwd: "",
      },
      rules: {
        company: [
          { required: true, message: "公司名称不能为空", trigger: "blur" },
        ],
        name: [{ required: true, message: "用户名不能为空", trigger: "blur" }],
        phone: [
          { required: true, message: "手机号不能为空", trigger: "blur" },
          { min: 11, max: 11, message: "手机号码格式不正确", trigger: "blur" },
        ],
        captcha: [
          { required: true, message: "验证码不能为空", trigger: "blur" },
        ],
        pwd: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          { min: 6, max: 20, message: "密码长度为6-20位", trigger: "blur" },
        ],
        repwd: [{ validator: validateRepwd, trigger: "blur" }],
      },
      seconds: 60,
      captchaDisabled: false,
      showCountdown: false,
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            company: this.ruleForm.company,
            title: this.ruleForm.name,
            mobile: this.ruleForm.phone,
            code: this.ruleForm.captcha,
            password: this.ruleForm.pwd,
          };
          this.$http
            .post("/fireeye/public/regist", qs.stringify(data))
            .then((res) => {
              let data = res.data;
              console.log(data);
              if (data.code == 1) {
                this.$message.success("用户注册成功，即将跳转登录页面！");
                this.$router.push("/login");
              } else {
                this.$message.success("用户注册失败：" + data.msg);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    getCaptcha() {
      this.seconds = 60;
      this.captchaDisabled = true;
      this.showCountdown = true;
      this.$http
        .get("/fireeye/public/code/regist?mobile=" + this.ruleForm.phone)
        .then(
          (res) => {
            let data = res.data;
            if (data.code == 1) {
              this.$message.success("验证码已发送，请注意查收！");
            } else {
              this.$message.error("验证码发送失败，请重新尝试！");
            }
          },
          (err) => {
            this.captchaDisabled = false;
            this.showCountdown = false;
          }
        );
      let interval = setInterval(() => {
        this.seconds--;
        if (this.seconds <= 0) {
          clearInterval(interval);
          this.captchaDisabled = false;
          this.showCountdown = false;
        }
      }, 1000);
    },
  },
};
</script>

<style lang="less" scoped>
.login-form {
  width: 340px;
  text-align: left;
  .btns {
    margin-bottom: 20px;
    a {
      text-decoration: none;
      padding: 5px 10px;
      color: #000;
      font-weight: 600;
    }
    .active {
      border-bottom: 2px solid #0093ff;
    }
  }
  .form {
    .el-button.captcha-btn {
      width: 100%;
    }
    .login-btn {
      text-decoration: none;
      font-weight: 600;
      font-size: 12px;
      color: #666;
      float: right;
    }
  }
}
</style>